import { Component } from '@angular/core';
import { MojoBatchComponent } from 'mojo-batch';

@Component({
  selector: 'mojo-batch-operation-toolbar',
  templateUrl: './batch-operation-toolbar.component.html',
  styleUrls: ['./batch-operation-toolbar.component.scss'],
})
export class BatchOperationToolbarComponent extends MojoBatchComponent {}
